import { v4 as uuid } from "uuid";
import SettingsAPI from "@/api/SettingsAPI";
import { useLocation, useNavigate } from 'react-router-dom';

import { createSlice, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import {SETTINGS} from "@/actions/globalConst";
import { CompanyModel } from "@/models/Company";
import { Buffer } from "buffer";

import DB from "@/models/DB";
import {WorkhoursModel} from "@/models/Workhours/Workhours";
import { WebsiteSettingsModel } from "@/models/PPC/Settings/Website";

export const initialState = {
    tenant: null,
    view: SETTINGS.VIEW_OVERVIEW,
    key: "",
    settings_worktypes: [],
    settings_vatrates: [],
    settings_contacttypes: [],
    settings_website: null,
    workhours: null,
    error: null,
    preview_invoice_data: null,
    dropbox: null,
    api_state: SETTINGS.API_INIT,
    selectedTab: 1
};


const SettingsReducer = createSlice({
  name: 'settings',
  company: null,
  invoice: null,
  initialState,
  reducers: {
    setTabId(state, action) {
        console.log("mijn actie", action )
            state.selectedTab = action.payload.tabId
    }      
    // omit existing reducers here
  },
  extraReducers(builder) {
    builder.addCase(uploadPDFTemplate.fulfilled, (state, action) => {
      state.api_state = SETTINGS.API_READY;
      state.key = uuid().slice(0, 8);
        
    }).addCase(uploadPDFTemplate.rejected, (state, action) => {
        //    state.api_state = SETTINGS.API_E;
    }).addCase(uploadPDFTemplate.pending,(state, action) => {
      state.api_state = SETTINGS.API_PENDING;
    });
    
    builder.addCase(recreatePDF.fulfilled, (state, action) => {
      state.api_state = SETTINGS.API_READY;
        
    });    
    
        
      builder.addCase(disconnectDropboxAccount.fulfilled, (state, action) => {
        state.api_state = SETTINGS.API_READY;
        if(action.payload.data.dropboxSettings) {
            state.dropbox = action.payload.data.dropboxSettings;
        }
        state.key = uuid().slice(0, 8);
          
      }).addCase(disconnectDropboxAccount.rejected, (state, action) => {
          //    state.api_state = SETTINGS.API_E;
      }).addCase(disconnectDropboxAccount.pending,(state, action) => {
        state.api_state = SETTINGS.API_PENDING;
      });
      
      builder.addCase(setStorageBaseMap.fulfilled, (state, action) => {
        state.api_state = SETTINGS.API_READY;
        if(action.payload.data.dropboxSettings) {
            state.dropbox = action.payload.data.dropboxSettings;
        }
        state.key = uuid().slice(0, 8);
          
      }).addCase(setStorageBaseMap.rejected, (state, action) => {
          //    state.api_state = SETTINGS.API_E;
      }).addCase(setStorageBaseMap.pending,(state, action) => {
        state.api_state = SETTINGS.API_PENDING;
      });

      builder.addCase(authoriseDropBoxWithCode.fulfilled, (state, action) => {
            state.api_state = SETTINGS.API_READY;  
            if(action.payload.data.dropboxSettings) {
                state.dropbox = action.payload.data.dropboxSettings;
            }
            state.key = uuid().slice(0, 8);
      }).addCase(authoriseDropBoxWithCode.rejected, (state, action) => {
          //    state.api_state = SETTINGS.API_E;
      }).addCase(authoriseDropBoxWithCode.pending,(state, action) => {
        state.api_state = SETTINGS.API_PENDING;
      });
               
    builder.addCase(previewInvoice.fulfilled, (state, action) => {
        state.preview_invoice_data = (Buffer.from(action.payload.data.ar, 'base64')).toString('base64');
      state.key = uuid().slice(0, 8);
      state.error = null;
    }).addCase(previewInvoice.rejected, (state, action) => {
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    });
      
    builder.addCase(settingsInit.fulfilled, (state, action) => {
        if(action.payload.data.company) {
         state.company = new CompanyModel(action.payload.data.company);
        }
        if(action.payload.data.settingsInvoice) {
            state.settings_invoice = action.payload.data.settingsInvoice;
        }
        if(action.payload.data.workTypes) {
            state.settings_worktypes = action.payload.data.workTypes;
        }
        if(action.payload.data.vatRates) {
            state.settings_vatrates = action.payload.data.vatRates;
        }
        if(action.payload.data.contacttypes) {
            state.settings_contacttypes = [...action.payload.data.contacttypes];
        }
        if(action.payload.data.dropboxSettings) {
            state.dropbox = action.payload.data.dropboxSettings;
        }
        if(action.payload.data.workhours) {
            state.workhours = DB.newCollection( action.payload.data.workhours, WorkhoursModel);
        }
        if(action.payload.data.tenantFields) {
            action.payload.data.tenantFields.forEach( (item) =>  {
                if(item['fieldkey'] == 'WEBSITE') {
                
                    state.settings_website = DB.newModel( item.data, WebsiteSettingsModel);        
                }
            } );
            
        }
        
      state.key = uuid().slice(0, 8);
      state.error = null;
      state.api_state = SETTINGS.API_READY;
    }).addCase(settingsInit.rejected, (state, action) => {
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    }).addCase(settingsInit.pending,(state, action) => {
        state.api_state = SETTINGS.API_PENDING;
      });
    
    builder.addCase(storeSettings.fulfilled, (state, action) => {
      state.key = uuid().slice(0, 8);
      state.error = null;
    }).addCase(storeSettings.rejected, (state, action) => {
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    });


    builder.addCase(storeBaseSetting2.fulfilled, (state, action) => {
        if(action.payload.data.settingsInvoice) {
            state.settings_invoice = action.payload.data.settingsInvoice;
        }
        if(action.payload.data.workTypes) {
            state.settings_worktypes = action.payload.data.workTypes;
        }
        if(action.payload.data.vatRates) {
            state.settings_vatrates = action.payload.data.vatRates;
        }
        if(action.payload.data.contacttypes) {
            state.settings_contacttypes = [...action.payload.data.contacttypes];
        }
        if(action.payload.data.newModel) {
            state.settings_website = DB.newModel( action.payload.data.newModel.data, WebsiteSettingsModel);
            }
      state.key = uuid().slice(0, 8);
      state.error = null;
    }).addCase(storeBaseSetting2.rejected, (state, action) => {
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    });

   builder.addCase(removeBaseSetting.fulfilled, (state, action) => {
        if(action.payload.data.settingsInvoice) {
            state.settings_invoice = action.payload.data.settingsInvoice;
        }
        if(action.payload.data.workTypes) {
            state.settings_worktypes = action.payload.data.workTypes;
        }
        if(action.payload.data.vatRates) {
            state.settings_vatrates = action.payload.data.vatRates;
        }
        if(action.payload.data.contacttypes) {
            state.settings_contacttypes = action.payload.data.contacttypes;
        }
        
      state.key = uuid().slice(0, 8);
      state.error = null;
    }).addCase(removeBaseSetting.rejected, (state, action) => {
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    });

    builder.addMatcher(
      (action) => action.type == "switchtenant/pending",
      (state, action) => {
        state.maps = [];
        state.files = [];
        state.selected = false;
        state.api_state = SETTINGS.API_INIT;
       })
    
  }
});

export const settingsInit = createAsyncThunk(SETTINGS.API_INIT, async (data, event) => {
    let response = null;
    try {
          response = await SettingsAPI.settingsInit(data)
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const storeSettings = createAsyncThunk(SETTINGS.API_SAVE, async (data, event) => {
    let response = null;
    try {
          response = await SettingsAPI.storeSettings(data)
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const storeBaseSetting2 = createAsyncThunk(
    SETTINGS.API_SAVE_BASE_SETTINGS, 
    async (data:any, event) => {
        let response = null;
        try {
          response = await SettingsAPI.storeBaseSettings(data.data, data.type)
        } catch (err) {
            return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
        }
    return response.data;
  }
)

export const editWebsite = createAsyncThunk(
    "editWebsite", 
    async (data:any, event) => {
        let response = null;
        try {
          response = await SettingsAPI.editWebsite(data)
        } catch (err) {
            return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
        }
    return response.data;
  }
)

export const removeBaseSetting = createAsyncThunk(
    SETTINGS.API_REMOVE_BASE_SETTING, 
    async (data:any, event) => {
        let response = null;
        try {
          response = await SettingsAPI.removeBaseSettings(data.data, data.type)
        } catch (err) {
            return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
        }
    return response.data;
  }
)

export const previewInvoice = createAsyncThunk(
    SETTINGS.API_GET_PREVIEW_INVOICE, 
    async (data, event) => {
        let response = null;
        try {
          response = await SettingsAPI.previewInvoice(data)
        } catch (err) {
            return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
        }
    return response.data;
  }
  
  
)
export const authoriseDropBoxWithCode = createAsyncThunk(
    SETTINGS.API_AUTHORISE_DROPBOX_WITH_CODE, 
    async (data:String, event) => {
        let response = null;
        try {
          response = await SettingsAPI.dropboxAuthoriseWithCode(data)
        } catch (err) {
            return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
        }
    return response.data;
  }
  
  
)

export const setStorageBaseMap = createAsyncThunk(
    SETTINGS.API_SET_STORAGE_BASEMAP, 
    async (data, event) => {
        let response = null;
        try {
          response = await SettingsAPI.setStorageBaseMap(data)
        } catch (err) {
            return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
        }
    return response.data;
  }
  
  
)

export const disconnectDropboxAccount = createAsyncThunk(
    SETTINGS.API_DISCONNECT_DROPBOX_ACCOUNT, 
    async (data, event) => {
        let response = null;
        try {
          response = await SettingsAPI.disconnectDropboxAccount()
        } catch (err) {
            return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
        }
    return response.data;
  })
  
  export const uploadPDFTemplate = createAsyncThunk(
    "uploadPDFTemplate",
    async (data:any = null, event) => {
      let response = null;
      try {
        
            response = await SettingsAPI.storePDFTemplate(data.file, data.filedata);
      } catch (err) {
        return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
      }
      return response.data;
    }
  )

  export const recreatePDF = createAsyncThunk(
    "recreatePDF",
    async (data:any = null, event) => {
      let response = null;
      try {
        
            response = await SettingsAPI.recreatePDF(data);
            return response;
      } catch (err) {
        
        return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
      }
      return response.data;
    }
  )
  
  



export const { setTabId } = SettingsReducer.actions;
export default SettingsReducer.reducer